import React from "react";
import { useState } from 'react';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getIdSpotLoc, getLivraison, getRidingPeriod, getPanier, getUserData, getCommentaire, getAccess } from "../../store/selectors.js";

import { accessoiresSlice } from "../../store/accessoiresSlice.js";

// API fetch
import axios from "axios";
import { baseURL, cloudRunBaseURL } from '../../config/api-config.js';

//created components
import AccessGallery from '../../pages/manager/contrat/step3/components/accessgallery/AccessGallery.jsx'

//MUI
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';

//Utils functions
import prepaMailContrat from "../../utils/prepa-mail-contrat.js" //params : fullContrat 
import calculDuree from '../../utils/calcul_duree.js' //we import this method because there is a bug to store the duree in Redux (infinite loop)

//import Fetch API functions
import { getAllTarifs } from '../../database/fetchApi.js'

// tools and component for date picker
import dayjs from 'dayjs';

function ResaStarter({ currentContrat, accessoires, articles }) {

    const [cautionType, setCautionType] = useState(0); //state : modify total price
    const [cautionDetails, setCautionDetails] = useState(""); //state : modify total price
    const [comment2, setComment2] = useState("");
    const [insertError, setInsertError] = useState("");
    const [allSuccess, setAllSuccess] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [tarifs, setTarifs] = useState([]);
    const accessList = useSelector(getAccess);

    const dispatch = useDispatch();

    let garantiesList = [
        "- Choisissez -", "Pièce d'identité", "Empreinte CB", "Chèque", "Autre"
    ];

    let datesContrat = [currentContrat.date1, currentContrat.date2]
    let period = [datesContrat, [currentContrat.h1, currentContrat.h2]]
    const dureeObject = calculDuree(period);

    React.useEffect(() => { //change opening hours when spot change (idspot as dependency)

        async function initTarifs() { //we add this inner function to manage asynchrone
            let allTarifs = await getAllTarifs();
            setTarifs(allTarifs)
        } //end of async function
        initTarifs(); //call the inner asnchrone function 
    }, [])

    function insertAccess(dataContrat) {
        setShowLoading(true);
        let batch = [];

        accessList.map((ligne) => { // for each article of the panier...

            let body = {//prepare the json body sent in request
                article_id: ligne.id_article,
                contrat_id: dataContrat.id_contrat,
                qte: ligne.qte,
                rendu: 0
            }

            batch.push(body);


        })//end of map

        axios.post(`${baseURL}/contrat-access/bulk`, batch)
            .then((response) => {
                if (response.status === 201) { //isnertion OK

                    modifContrat(dataContrat); //remplir les infos de caisse

                }
                else { //insertion problème
                    setInsertError("Erreur lors de l'ajout des accessoires. Vous pouvez essayer à nouveau");
                    return response.status
                }
            })
            .catch(error => {
                setInsertError("Erreur lors de l'ajout des aaccessoires. Vous pouvez essayer à nouveau");
                return error
            })


    }

    function modifContrat(dataContrat) {

        // we force update just to get response with all jointured tables
        axios.put(`${baseURL}/contrat/${dataContrat.id_contrat}`, {
            garantie: garantiesList[cautionType] + "-" + cautionDetails,
            commentaire2: comment2
        })
            .then((response) => {
                if (response.status === 200) { //isnertion OK

                    sendMail(response.data.data);
                }
                else { //insertion problème
                    return response.status
                    console.log(response.status);
                }
            })
            .catch(error => {
                return error
                console.log(error);
            })



    }

    function sendMail(fullContrat) {

        let body = {
            //to: "manuel.vivion@gmail.com",
            to: fullContrat.Client.email,
            bcc: "sylvainboufflers2@gmail.com,manuel.vivion@gmail.com",
            subject: "[Début Location] -  " + fullContrat.ref_contrat,
            html: prepaMailContrat(fullContrat, articles, accessoires, dureeObject, tarifs)
        };

        axios.post(`${baseURL}/mailing/mail-confirm`, body)
            .then((response) => {

                if (response.status === 200) { //isnertion OK
                    dispatch(accessoiresSlice.actions.resetPanier());
                    setAllSuccess(true);
                    setShowLoading(false);
                }
                else { //insertion problème

                    //// ---
                    setInsertError("Erreur lors de l'envoie du mail de confirmation. Vous pouvez essayer à nouveau");
                    /// --
                }
            })
            .catch(error => {
                //// ---
                setInsertError("Erreur lors de l'envoie du mail de confirmation. Vous pouvez essayer à nouveau");
                /// --

            })
    }



    return (
        <div className="resa-starter">

            <AccessGallery accessoires={accessoires} startResa={true} />


            <div className="step6-mode-paiement">
                <h3>Dépôt de garantie :</h3>
                <div className="step6-mode-paiement-ligne">
                    <Select
                        className="step6-mode-paiement-ligne-caution"
                        value={cautionType}
                        label="Type de garantie"
                        size="small"
                        onChange={e => setCautionType(e.target.value)}
                    >
                        {garantiesList.map((gar, index) =>
                            <MenuItem key={index} value={index}>{gar}</MenuItem>
                        )}


                    </Select>
                    <TextField
                        className="step6-mode-paiement-ligne-details"
                        size="small"
                        label="Détails"
                        variant="outlined"
                        onChange={e => setCautionDetails(e.target.value)}
                        value={cautionDetails} />

                </div>

            </div>

            <div className="step6-mode-paiement">
                <h3>Commentaire additionnel :</h3>
                <div className="panier-modal-bottom-commentaires">
                    <TextField
                        fullWidth
                        label="Commentaire 2"
                        placeholder="facultatif"
                        /* defaultValue=" " */
                        value={comment2}
                        onChange={e => setComment2(e.target.value)}
                        multiline
                        maxRows={3}
                    />
                </div>
            </div>

            <div className="resa-starter-bottom">
                <Button
                    variant="contained"
                    disabled={cautionType === 0}
                    onClick={_ => insertAccess(currentContrat)}>
                    Démarrer la location
                </Button>
                {insertError.length > 0 ?
                    <Alert
                        className="step5-bottom-alert"
                        severity="error">
                        {insertError}
                    </Alert>
                    : null
                }
                {showLoading === true ?
                    <CircularProgress />
                    : null
                }
                {allSuccess === true ?
                    <Alert
                        className="step5-bottom-alert"
                        severity="success">
                        La réservation est maintenant confirmée. La location a débuté (un mail de confirmation a été envoyé)
            </Alert>
                    : null
                }
            </div>

        </div>
    );
}

export default ResaStarter